import {TRANSACTIONS} from '../../../endpoints'
import {apiPublic, apiExternal} from '../../../api'
import types from '../types/addCreditCard'
import {endpoint as endpointText} from '../../../common/text'
import {ApiError} from '../../activity/schemas'
import Payment from 'payment'
import config from "../../../config"
import * as Sentry from '@sentry/react'

export default class addCreditCard {
  static getDeposit(code) {
    return function(dispatch) {

      dispatch({type: types.VALIDATE_CODE_AND_GET_DEPOSIT, payload: {code}})

      return apiPublic.get(TRANSACTIONS + '/pages/deposit/card/' + code)
        .then(response => {
          const {completed, deposit} = response.data.description
          dispatch(addCreditCard.getDepositSuccess(completed !== '', deposit))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(addCreditCard.getDepositFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(addCreditCard.getDepositFail(message))
        })
    }
  }

  static getDepositSuccess(completed, deposit) {
    return {
      type: types.VALIDATE_CODE_AND_GET_DEPOSIT_SUCCESS,
      payload: {
        completed,
        deposit,
      },
    }
  }

  static getDepositFail(error) {
    return {
      type: types.VALIDATE_CODE_AND_GET_DEPOSIT_FAIL,
      payload: {
        error,
      },
    }
  }

  static setCardNumber(number) {
    return {
      type: types.SET_CARD_NUMBER,
      payload: {number},
    }
  }

  static setCardExpiry(expiry) {
    return {
      type: types.SET_CARD_EXPIRY,
      payload: {expiry},
    }
  }

  static setCardCVC(cvc){
    return {
      type: types.SET_CARD_CVC,
      payload: {cvc},
    }
  }

  static setCardholderName(cardholderName) {
   return {
     type: types.SET_CARDHOLDER_NAME,
     payload: {cardholderName},
   }
  }

  static setDocumentType(documentType) {
    return {
      type: types.SET_DOCUMENT_TYPE,
      payload: {documentType},
    }
  }

  static setDocumentNumber(documentNumber) {
    return {
      type: types.SET_DOCUMENT_NUMBER,
      payload: {documentNumber},
    }
  }

  static setCardType(type) {
    return {
      type: types.SET_CARD_TYPE,
      payload: {type},
    }
  }

  static saveCard() {
    return function (dispatch, getState) {

      const state = getState().ui.addCreditCard.addCreditCard

      const code = state.code
      const number = state.number
      const expiry = state.expiry
      const cvc = state.cvc
      const cardholderName = state.cardholderName
      const documentType = state.documentType
      const documentNumber = state.documentNumber
      const type = Payment.fns.cardType(number)

      if (Payment.fns.validateCardNumber(number) === false) {
        dispatch(addCreditCard.saveCardFailed('Número de la tarjeta inválido'))
        return Promise.resolve(false)
      }
      if (Payment.fns.validateCardExpiry(expiry) === false) {
        dispatch(addCreditCard.saveCardFailed('Fecha de expiración inválida'))
        return Promise.resolve(false)
      }
      if (Payment.fns.validateCardCVC(cvc, Payment.fns.cardType(number)) === false) {
        dispatch(addCreditCard.saveCardFailed('Código de seguridad inválido'))
        return Promise.resolve(false)
      }

      dispatch({type: types.SAVE_CARD})

      const split = expiry.split('/')
      const month = typeof split[0] === 'string' ? split[0].trim() : ''
      const year = typeof split[1] === 'string' ? Number(split[1].trim()) % 100 : ''

      return createMPCardToken(number, month, year, cvc, cardholderName, documentType, documentNumber)
        .then(cardToken => {
          const paymentMethod = translateType(type)
          const formData = new FormData()

          formData.append('card_token', cardToken)
          formData.append('payment_method', paymentMethod)

          return apiPublic.post(TRANSACTIONS + '/pages/deposit/card/' + code, formData)
            .then(response => {
              dispatch(addCreditCard.saveCardSuccess())
            })
            .catch(error => {
              let message = ''
              if (error.response) {
                switch (error.response.status) {
                  case 404:
                    message = 'Algo salió mal'
                    break
                  default:
                    message = error.response.data.description
                }
              } else if (error.request) {
                message = endpointText.internetMayBeTheProblem
              } else {
                message = endpointText.somethingWentWrong
              }
              dispatch(addCreditCard.saveCardFailed(message))
            })
        }, error => handleMPError(error, dispatch)
      )
    }
  }

  static saveCardSuccess() {
    return {
      type: types.SAVE_CARD_SUCCESS,
    }
  }

  static saveCardFailed(error) {
    return {
      type: types.SAVE_CARD_FAIL,
      payload: {
        error,
      },
    }
  }
}

function createMPCardToken(number, expiryMonth, expiryYear, cvc, cardholderName, documentType, documentNumber) {
  return apiExternal.post(
    'https://api.mercadopago.com/v1/card_tokens?public_key=' + config.MERCADOPAGO_PUBLIC_KEY,
    {
      card_number: number,
      expiration_month: expiryMonth,
      expiration_year: '20' + expiryYear,
      security_code: cvc,
      cardholder: {
        name: cardholderName,
        identification: {
          number: documentNumber,
          type: documentType,
        },
      },
    },
  )
    .then(response => {
      return response.data.id
    }, error => {
      throw error
    })
}

function translateType(type) {
  switch (type) {
    case 'mastercard':
      return 'master'
    case 'dinersclub':
      return 'diners'
    default:
      return type
  }
}

function handleMPError(error, dispatch) {
  let message = ''
  if (error.response) {
    message = getMPCardTokenErrorMessage(error.response.data)
  } else if (error.request) {
    message = 'Problemas de conexión'
  } else {
    message = 'Algo salió mal'
  }
  try {
    Sentry.captureMessage(`${error.toString()}\njson: ${JSON.stringify(error.response.data)}`)
  } catch (e) {
    console.warn('failed to send error to sentry: ', e)
  }
  dispatch(addCreditCard.saveCardFailed(message))
  return false
}

// https://www.mercadopago.com.ar/developers/es/guides/payments/api/handling-responses
function getMPCardTokenErrorMessage(response) {
  if (Array.isArray(response.cause) && response.cause.length > 0) {
    const cause = response.cause[0]
    switch (cause.code) {
      case '205':
        return 'Ingresá el número de tu tarjeta'
      case '208':
        return 'Ingresá el mes de expiración'
      case '209':
        return 'Ingresá el año de expiración'
      case '212':
      case '213':
      case '214':
        return 'Ingresá el documento'
      case '220':
        return 'Ingresá tu banco emisor'
      case '221':
        return 'Ingresá el nombre del titular de la tarjeta'
      case '224':
        return 'Ingresá el código de seguridad'
      case '301':
        return 'La fecha de expiración es inválida'
      case '316':
        return 'El nombre del titular de la tarjeta es inválido'
      case '322':
      case '323':
        return 'El tipo de documento es inválido'
      case '324':
        return 'El número de documento es inválido'
      case '325':
      case '326':
        return 'La fecha de expiración es inválida'
      case 'E301':
      case 'E202':
        return 'El número de la tarjeta es inválido'
      case 'E204':
        return 'El mes de expiración es inválido'
      case 'E302':
        return 'El código de seguridad es inválido'
      default:
        return 'Algo salió mal'
    }
  } else {
    return 'Algo salió mal'
  }
}




// WEBPACK FOOTER //
// ./src/sections/addCreditCard/actions/addCreditCard.js